module.exports = __webpack_public_path__ + "static/img/tr_qrcode.32545080.jpg";